import React, { useState } from "react";
import { TableRow } from "@material-ui/core";
import classnames from "classnames";

import { ResponsiveTableCell } from "../../../../../../components/layout/responsive-table/responsive-table-cell.component";
import { RoundedBlueButton } from "../../../../../../components/form-controls/button/rounded-blue-button/rounded-blue-button.component";

import { getProductRowPrice } from "../../types/iproduct-row/iproduct-row.functions";

import { SearchProductsTableRowProps } from "./search-products-table-row.props";
import { useSearchProductsTableRowStyles } from "./search-products-table-row.styles";

export const SearchProductsTableRow = (props: SearchProductsTableRowProps) => {
  const classes = useSearchProductsTableRowStyles();

  const [clicked, setClicked] = useState<boolean>(false);

  const handleClick = () => {
    if (!clicked) {
      setClicked(true);
      props.handleClickProduct(props.product);
    }
  };

  const buttonClasses = classnames({
    active: props.product.selected || clicked,
    [classes.added]: props.product.selected || clicked,
  });

  return (
    <TableRow key={props.product.sku} id={props.product.sku}>
      <ResponsiveTableCell>
        <img
          src={props.product.image || "https://via.placeholder.com/40x40?text=N/A"}
          width="40"
          alt={props.product.name}
        />
      </ResponsiveTableCell>
      <ResponsiveTableCell component="th" scope="row">
        {props.product.sku}
      </ResponsiveTableCell>
      <ResponsiveTableCell align="left">{props.product.name}</ResponsiveTableCell>
      <ResponsiveTableCell align="left">{props.product.subcategory}</ResponsiveTableCell>
      <ResponsiveTableCell align="left">{getProductRowPrice(props.product)}</ResponsiveTableCell>
      <ResponsiveTableCell align="right">
        <RoundedBlueButton onClick={handleClick} className={buttonClasses}>
          {props.product.selected ? "Added" : clicked ? "Adding..." : "Add"}
        </RoundedBlueButton>
      </ResponsiveTableCell>
    </TableRow>
  );
};
